import PageModel from '@/models/pageModel';

export class Pages extends PageModel {
    static moduleName = 'pages';
    static moduleEntityName = 'page';
    static listTitle = 'Статические страницы';
    static createTitle = 'Добавление новой страницы';
    static apiPrefix = 'pages';
}
